export const HeaderData = [
  {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
    heading: "Get Everything About Us",
  },
  {
    title: "Our Service",
    path: "#",
    subNav: [
      {
        subTitle: "Our Services",
        heading: " Pick a Service to Get Started ",
        path: "/Home/Our_Services",
      },
      {
        subTitle: "Service Details",
        heading: "Massage Therapy",
        path: "/Home/Our_Services/Service_Details",
      },
    ],
  },
  {
    title: "Other Pages",
    path: "#",
    subNav: [
      {
        subTitle: "Our Team",
        heading: "Our Staff Member",
        path: "/Home/Our_Team",
      },
      {
        subTitle: "Team Details",
        heading: "Know About Alexa Boss",
        path: "/Home/Our_Team/Team_Details",
      },

      {
        subTitle: "Testimonial",
        heading: "Awesome Clients, Awesome Reviews",
        path: "/Home/Testimonial",
      },
      {
        subTitle: "Gallery",
        heading: "Our Spa and Salon Photo Gallery",
        path: "/Home/Gallery",
      },
      {
        subTitle: "Our Works",
        heading: "View Our Latest Works",
        path: "/Home/Our_Works",
      },
      {
        subTitle: "Work Details",
        heading: "Full Body Massage",
        path: "/Home/Our_Works/Work_Details",
      },

      {
        subTitle: "FAQ",
        heading: "Questions and Answers",
        path: "/Home/FAQ",
      },
      {
        subTitle: "Pricing Table",
        heading: "Awesome Pricing Plane",
        path: "/Home/Pricing_Table",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        path: "/Home/Comming_Soon",
      },
      {
        subTitle: "404",
        heading: "404 Error",
        path: "/Home/Error404",
      },
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Blogs",
        heading: "Read Our News and Articles",
        path: "/Home/Blogs",
      },
      {
        subTitle: "Blog Details",
        heading: "5 Makeup Trends That Are Here To Stay",
        path: "/Home/Blogs/Blog_Details",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/Home/Contact_Us",
    heading: "Get In Touch",
  },
  {
    title: "Make An Appointment",
    heading: "Book an Appointment",
    path: "/Home/Make_An_Appointment",
  },
];
